import "../../scss/forms.scss";
import "./_style.scss";
import "react-dates/lib/css/_datepicker.css";
import "react-select/dist/react-select.min.css";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";

import React from "react";

import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Label,
  Button
} from "reactstrap";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as VisualizarActions from "../../store/ducks/protocolo/visualizar/actions";
import "react-dates/initialize";
import { dateHourToBr } from '../../util/date';
import { ContextLoader } from '../ContextLoader';
import { 
  GridDinamico, 
  getDynamicConfig, 
} from '@newspacebpo/newspace-react-grid-filter-bfveic';
import { redirectHandled } from "../../util/helper";


class VisualizarProtocolo extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount(){
    this.idProtocolo = this.props.match.params["idProtocolo"];
    getDynamicConfig('visualizar', 'protocolo', '', {idProtocolo: this.idProtocolo});
    this.props.actions.viewRequest({
      id: this.idProtocolo
    });
  }

  formatarData(valor) {
      return !!valor ? new Date(valor).toLocaleString() : null;
  }

  tratarBool(valor) {
    return valor  ? "Sim" : "Não" ;
  }

  tratarPropostaContrato = (valor, row) => {
    return this.props.tpProtocolo==="Cartão Consignado" ? row.proposta : valor
  }

  render() {
    return (
      <ContextLoader isLoading={this.props.isLoading}>
        <Row>
          <Col sm={8} md={12} style={{ flexBasis: "auto" }}>
            <Card>
              <CardHeader>
                <strong>Visualizar Protocolo</strong>{" "}
              </CardHeader>
              <CardBody>
                <Label>Protocolo</Label>
                <form className="needs-validation">
                  <Col className="form-row justify-content-start">
                    <Container className="div_back">
                      <Row className="mt-2">
                        <Col sm={6} md={6}>
                          <Label className="label">N. Protocolo: </Label>
                          <Label className="m-1">{this.props.dados.NumeroProtocolo}</Label>
                        </Col>
                        <Col sm={6} md={6}>
                          <Label className="label">Data/Hora da Geração: </Label>
                          <Label className="m-1">
                            {dateHourToBr(this.props.dados.DataGeracao)}
                          </Label>
                        </Col>
                      </Row>

                      <Row className="mt-2">
                        <Col sm={6} md={6}>
                          <Label className="label">Tipo Protocolo: </Label>
                          <Label className="m-1">{this.props.dados.TipoProtocolo}</Label>
                        </Col>
                        <Col sm={6} md={6}>
                          <Label className="label">Status Recepção: </Label>
                          <Label className="m-1">{this.props.dados.StatusRecepcao}</Label>
                        </Col>
                      </Row>

                      <Row className="mt-2">
                        <Col sm={6} md={6}>
                          <Label className="label">Número do envelope:</Label>
                          <Label className="m-1">{this.props.dados.NumeroEnvelope}</Label>
                        </Col>
                        <Col sm={6} md={6}>
                          <Label className="label">Responsável pela Geração:</Label>
                          <Label className="m-1">{this.props.dados.UsuarioResponsavel}</Label>
                        </Col>
                      </Row>
                    </Container>
                    <Row className="col-md-12 col-sm-12 col-lg-12 col-xs-12">
                      <Col className="mt-3" sm={3} md={3}>
                        <Label>Detalhes do Protocolo</Label>
                      </Col>
                      <Col className="mt-1 text-right" sm={3} md={9}>
                        <Button onClick={() => redirectHandled(this.props.history, '/protocolo/consulta/visualizar/imprimir')}>Imprimir</Button>
                      </Col>
                    </Row>
                    <Row className="col-md-12 col-sm-12 col-lg-12 col-xs-12">
                      <Col sm={12} md={12}>
                        <Label>Total de Contratos: </Label>
                            <Label className="m-1">{ this.props.dados.TotalContratos || 0 }</Label>
                      </Col>
                      <Col sm={3} md={3}>
                        &nbsp;
                      </Col>
                    </Row>
                  </Col>
                </form>
                <Row className="row_protocolo">
                <Col>
                  <GridDinamico pagination={false}/>
                </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </ContextLoader>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.visualizarProtocolo.loading,
  dados: state.visualizarProtocolo.dados,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(VisualizarActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VisualizarProtocolo);
